import { render, staticRenderFns } from "./VPhone.vue?vue&type=template&id=33b32ea4&"
import script from "./VPhone.vue?vue&type=script&lang=js&"
export * from "./VPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports